import { useEffect, useCallback } from 'react';
import { req, useApiGet, useApiLoading } from 'react-reqq-lite';
import * as actions from './actions';
import * as c from './constants';

export const useChannelList = (params) => {
  const isLoading = useApiLoading(c.CHANNEL_LIST, 'get');
  const data = useApiGet(c.CHANNEL_LIST, []);
  const pager = useApiGet(c.CHANNEL_PAGER, {});
  useEffect(() => {
    actions.listChannels(params);
  }, [params]);
  return [isLoading, data, pager];
};

export const useChannelSelected = () => {
  const isLoading = useApiLoading(c.CHANNEL_ITEM, 'get');
  const data = useApiGet(c.CHANNEL_ITEM, {});
  return [isLoading, { id: 1, name: 'Test Channel' }, data];
};

export const useSelectChannel = (id) => {
  useEffect(() => {
    if (!id) {
      req.set(c.CHANNEL_ITEM, null);
      return;
    }
    actions.selectChannel(id);
  }, [id]);
};

export const useCreateChannel = () => {
  const isLoading = useApiLoading(c.CHANNEL_ITEM, 'post');
  const submit = useCallback((payload, onSuccess) => {
    actions.createChannel(payload, onSuccess);
  }, []);
  return [isLoading, submit];
};

export const useUpdateChannel = () => {
  const isLoading = useApiLoading(c.CHANNEL_ITEM, 'put');
  const submit = useCallback((id, payload, onSuccess) => {
    actions.updateChannel(id, payload, onSuccess);
  }, []);
  return [isLoading, submit];
};

export const useRemoveChannel = () => {
  const isLoading = useApiLoading(c.CHANNEL_ITEM, 'remove');
  const submit = useCallback((id, onSuccess) => {
    actions.removeChannel(id, onSuccess);
  }, []);
  return [isLoading, submit];
};

export const useChannelCountCard = (name, filter) => {
  const isLoading = useApiLoading(`${c.COUNT_CARD}/${name}`, 'get');
  const { value } = useApiGet(`${c.COUNT_CARD}/${name}`, {});
  useEffect(() => {
    const action = actions.getCountCard[name];
    if (typeof action === 'function') action(filter);
  }, [name, filter]);
  return [isLoading, value];
};

/* CHANNEL BRANCH */
export const useChannelBranchList = (params) => {
  const isLoading = useApiLoading(c.CHANNEL_BRANCH_LIST, 'get');
  const meta = useApiGet(c.CHANNEL_BRANCH_PAGER, {});
  const list = useApiGet(c.CHANNEL_BRANCH_LIST, []);
  useEffect(() => {
    actions.listChannelBranch(params);
  }, [params]);
  return [isLoading, list, meta];
};

export const useCreateChannelBranch = () => {
  const isLoading = useApiLoading(c.CHANNEL_BRANCH_ITEM, 'post');
  const submit = useCallback((payload, onSuccess) => {
    actions.createChannelBranch(payload, onSuccess);
  }, []);
  return [isLoading, submit];
};

export const useUpdateChannelBranch = () => {
  const isLoading = useApiLoading(c.CHANNEL_BRANCH_ITEM, 'put');
  const submit = useCallback((id, payload, onSuccess) => {
    actions.updateChannelBranch(id, payload, onSuccess);
  }, []);
  return [isLoading, submit];
};

export const useDeleteChannelBranch = () => {
  const isLoading = useApiLoading(c.CHANNEL_BRANCH_ITEM, 'remove');
  const submit = useCallback((id, onSuccess) => {
    actions.deleteChannelBranch(id, onSuccess);
  }, []);
  return [isLoading, submit];
};
/* CHANNEL BRANCH END */
